/**
 * Consultations domain — admin UI registration (Sub-project III, Task 5).
 *
 * Injects per-record action toolbars into the generic-framework
 * detail pages via the `detailHeader` slot.
 */
import { registerAdminUI } from '@/admin/generic/registry';
import ConsultationActions from './components/ConsultationActions.vue';

registerAdminUI('consultations.consultationbooking', {
    slots: {
        detailHeader: ConsultationActions,
    },
});
